<template>
    <div
v-if="dialogFormVisible" custom-class="box-dialog" class="box-dialog" fullscreen :visible.sync="dialogFormVisible"
        append-to-body="false" width="85%" height="650px" :close-on-click-modal="false" :close-on-press-escape="false"
        :show-close="false" title="档案信息"
>

        <el-tabs v-model="activeTabName" class="demo-tabs" @tab-click="onTabClick">
            <el-tab-pane label="档案信息" name="0" />
            <el-tab-pane label="任职信息" name="1" />
            <el-tab-pane label="调离信息" name="2" />
            <el-tab-pane label="相关学历及职业技能证书" name="3" />
            <el-tab-pane label="工作成长记录" name="4" />
            <el-tab-pane label="家庭成员" name="5" />
            <el-tab-pane label="变动信息" name="6" />
            <el-tab-pane label="人事合同" name="7" />
        </el-tabs>

        <div :class="'el-tabs-top'">
            <div v-if="activeTabName==='0'" class="tab_0">
                <el-form :model="vo" @submit.native.prevent>
                    <div style="width:100%;" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                                <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="6" style="border-left:none !important;padding:0 !important">
                                                <div class="spanDiv">
                                                    <span class="spanStatus"></span>
                                                    <span class="spanTitle">基本信息</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td ref="tdlbl_姓名" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'name'" class="field">姓名</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="name"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入姓名','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'姓名','propName':'name','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.name','option':[]}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_性别" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'gender'" class="field">性别</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="gender"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：男\n1：女\n2：其他','elementReadonly':1,'elementType':'select','emptyMessage':'请选择性别','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'性别','propName':'gender','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.gender','option':[{'value':'0','name':'男'},{'value':'1','name':'女'},{'value':'2','name':'其他'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_证件照片" class="el-table__cell tdlbl tdw13" colspan="1">

                                            <span v-field-lbl="'idPhotoUrl'" class="field">证件照片</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="idPhotoUrl"
                                                :field="{'defaultValue':'idPhotoUrl','elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':null,'elementType':'file','emptyMessage':'请选择待上传图片','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'证件照片','propName':'idPhotoUrl','propType':'byte[]','textFormatter':'image/png','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'idphotourl','iconName':'bzdtp','model':'vo.idPhotoUrl','option':[],'downloadUrl':'/teacher/basicInfo/download','formTdAlign':'text-left','nameField':'idPhotoUrl','limitCount':null}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_身份证号" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'idCardNumber'" class="field">身份证号</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="idCardNumber"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入教师身份证号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'身份证号','propName':'idCardNumber','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.idCardNumber','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_出生日期" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'birthDate'" class="field">出生日期</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="birthDate"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'出生日期','propName':'birthDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'birthdate','iconName':'sjxzk','model':'vo.birthDate','option':[],'formTdAlign':'text-left','weekday':0}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_年龄" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'age'" class="field">年龄</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="age"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入年龄','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'年龄','propName':'age','propType':'Integer','textFormatter':'integer','valueMaxLength':null,'valueMinLength':null,'model':'vo.age','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_婚姻情况" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'maritalStatus'" class="field">婚姻情况</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="maritalStatus"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：未婚\n1：已婚\n2：离异','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择婚姻情况','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'婚姻情况','propName':'maritalStatus','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.maritalStatus','option':[{'value':'0','name':'未婚'},{'value':'1','name':'已婚'},{'value':'2','name':'离异'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_政治面貌" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'politicalStatus'" class="field">政治面貌</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="politicalStatus"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：中共党员\n1：中共预备党员\n2：共青团员\n3：群众','elementReadonly':1,'elementType':'select','emptyMessage':'请选择政治面貌','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'政治面貌','propName':'politicalStatus','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.politicalStatus','option':[{'value':'0','name':'中共党员'},{'value':'1','name':'中共预备党员'},{'value':'2','name':'共青团员'},{'value':'3','name':'群众'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_籍贯" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'nativePlace'" class="field">籍贯</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="nativePlace"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'籍贯','propName':'nativePlace','propType':'String','textFormatter':'textfield','valueMaxLength':100,'valueMinLength':null,'tbFieldName':'nativeplace','iconName':'puwb','model':'vo.nativePlace','option':[],'formTdAlign':'text-left','formTdColspan':8}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_民族" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'ethnicity'" class="field">民族</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="ethnicity"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入民族（56个民族）','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'民族','propName':'ethnicity','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.ethnicity','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_手机号" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'mobilePhone'" class="field">手机号</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="mobilePhone"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入手机号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'手机号','propName':'mobilePhone','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.mobilePhone','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_邮箱" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'emailAddress'" class="field">邮箱</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="emailAddress"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入邮箱地址','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'邮箱','propName':'emailAddress','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.emailAddress','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_毕业学校" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'graduationSchool'" class="field">毕业学校</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="graduationSchool"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入毕业学校','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'毕业学校','propName':'graduationSchool','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.graduationSchool','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_最高学历" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'highestDegree'" class="field">最高学历</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="highestDegree"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：小学\n1：初中\n2：中专\n3：高中\n4：专科\n5：本科\n6：硕士研究生\n7：博士研究生','elementReadonly':1,'elementType':'select','emptyMessage':'请选择最高学历','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'最高学历','propName':'highestDegree','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.highestDegree','option':[{'value':'0','name':'小学'},{'value':'1','name':'初中'},{'value':'2','name':'中专'},{'value':'3','name':'高中'},{'value':'4','name':'专科'},{'value':'5','name':'本科'},{'value':'6','name':'硕士研究生'},{'value':'7','name':'博士研究生'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_任职时间" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'appointmentDate'" class="field">任职时间</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="appointmentDate"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'任职时间','propName':'appointmentDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd HH:mm:ss','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'appointmentdate','iconName':'sjxzk','model':'vo.appointmentDate','option':[],'formTdAlign':'text-left','weekday':0}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_教师类别" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'teacherCategory'" class="field">教师类别</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="teacherCategory"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：否\n1：是','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择教师类别','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'教师类别','propName':'teacherCategory','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.teacherCategory','option':[{'value':'0','name':'否'},{'value':'1','name':'是'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_所学专业" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'major'" class="field">所学专业</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="major"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入所学专业','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'所学专业','propName':'major','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.major','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_专兼职" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'fullPartTime'" class="field">专兼职</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="fullPartTime"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：全职\n1：兼职','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择专兼职','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'专兼职','propName':'fullPartTime','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.fullPartTime','option':[{'value':'0','name':'全职'},{'value':'1','name':'兼职'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td ref="tdlbl_人员状态" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'personnelStatus'" class="field">人员状态</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw20" colspan="1">
                                            <form-item
ref="personnelStatus"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'v：t','elementReadonly':1,'elementType':'select','emptyMessage':'请选择人员状态','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'人员状态','propName':'personnelStatus','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.personnelStatus','option':[{'value':'v','name':'t'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                        <td ref="tdlbl_人才标识" class="el-table__cell tdlbl tdw13" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'talentIdentification'" class="field">人才标识</span>
                                        </td>
                                        <td class="el-table__cell tdcont " colspan="3">
                                            <form-item
ref="talentIdentification"
                                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：人才骨干\n1：青年干部','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择人才标识','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'人才标识','propName':'talentIdentification','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.talentIdentification','option':[{'value':'0','name':'人才骨干'},{'value':'1','name':'青年干部'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                                :vo="vo" :can-edit="canEdit"
/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <div v-if="activeTabName==='1'" class="tab_1">
                <el-form :model="vo" @submit.native.prevent>
                    <div style="width:100%;" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                                <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="6" style="border-left:none !important;padding:0 !important">
                                                <div class="spanDiv">
                                                    <span class="spanStatus"></span>
                                                    <span class="spanTitle">任职信息</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template>
                                        <tr>
                                            <td
colspan="6"
                                                style="padding:0 !important;border-left:none !important;border-bottom:none !important"
>
                                                <work-post ref="workP" :vo="vo" :can-edit="canEdit" />
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <div v-if="activeTabName==='2'" class="tab_2">
                <el-form :model="vo" @submit.native.prevent>
                    <div style="width:100%;" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                                <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="6" style="border-left:none !important;padding:0 !important">
                                                <div class="spanDiv">
                                                    <span class="spanStatus"></span>
                                                    <span class="spanTitle">任职信息</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <div v-if="activeTabName==='3'" class="tab_3">
                <el-form :model="vo" @submit.native.prevent>
                    <div style="width:100%;" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                                <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="6" style="border-left:none !important;padding:0 !important">
                                                <div class="spanDiv">
                                                    <span class="spanStatus"></span>
                                                    <span class="spanTitle">调离信息</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td class="el-table__cell tdcont tdcont-innertb" colspan="6">
                                            <inner-table
id="innerTable" ref="innerTable"
                                                :listviewurl="'teacher.certificate.list'" :exclude-fields="''"
                                                 :link-prop-name="''" :can-edit="1"
                                                :can-delete="1" :can-add="1" :in-line-edit="1" :show-toolbar="0"
                                                :pagination="0"
/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <div v-if="activeTabName==='4'" class="tab_4">
                <el-form :model="vo" @submit.native.prevent>
                    <div style="width:100%;" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                                <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="6" style="border-left:none !important;padding:0 !important">
                                                <div class="spanDiv">
                                                    <span class="spanStatus"></span>
                                                    <span class="spanTitle">工作成长记录</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td class="el-table__cell tdcont tdcont-innertb" colspan="6">
                                            <inner-table
id="innerTable" ref="innerTable"
                                                :listviewurl="'teacherWorkResume.list'" :exclude-fields="''"
                                                  :link-prop-name="''" :can-edit="1"
                                                :can-delete="1" :can-add="1" :in-line-edit="1" :show-toolbar="0"
                                                :pagination="0"
/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <div v-if="activeTabName==='5'" class="tab_5">
                <el-form :model="vo" @submit.native.prevent>
                    <div style="width:100%;" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                                <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="6" style="border-left:none !important;padding:0 !important">
                                                <div class="spanDiv">
                                                    <span class="spanStatus"></span>
                                                    <span class="spanTitle">家庭成员</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td class="el-table__cell tdcont tdcont-innertb" colspan="6">
                                            <inner-table
id="innerTable" ref="innerTable"
                                                :listviewurl="'teacher.familyMembers.list'" :exclude-fields="''"
                                                  :link-prop-name="''" :can-edit="1"
                                                :can-delete="1" :can-add="1" :in-line-edit="1" :show-toolbar="0"
                                                :pagination="0"
/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <div v-if="activeTabName==='6'" class="tab_6">
                <el-form :model="vo" @submit.native.prevent>
                    <div style="width:100%;" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                                <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="6" style="border-left:none !important;padding:0 !important">
                                                <div class="spanDiv">
                                                    <span class="spanStatus"></span>
                                                    <span class="spanTitle">变动信息</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <div v-if="activeTabName==='7'" class="tab_7">
                <el-form :model="vo" @submit.native.prevent>
                    <div style="width:100%;" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                                <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="6" style="border-left:none !important;padding:0 !important">
                                                <div class="spanDiv">
                                                    <span class="spanStatus"></span>
                                                    <span class="spanTitle">合同信息</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td class="el-table__cell tdcont tdcont-innertb" colspan="6">
                                            <inner-table
id="innerTable" ref="innerTable"
                                                :listviewurl="'teacher.contractInfo.list'" :exclude-fields="''"
                                                  :link-prop-name="''" :can-edit="1"
                                                :can-delete="1" :can-add="1" :in-line-edit="0" :show-toolbar="0"
                                                :pagination="0"
/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>

            <Basicform
ref="basicform" :title="formTitle" :module-code="moduleInfo.moduleCode"
                 :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :toolbar-btns="busiformBtns"
                 :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened"
                 :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited"
>
                 <template #default="slotProps">
                     <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
                 </template>
             </Basicform>

    </div>
</template>

<script>
//import AppointmentForm from './appointmentForm.vue'
export default {
    components: {
        //AppointmentForm,
    },
    props: {
        vo: {
            type: Object,
            default: function() {
                return {}
            }
        },
        canEdit: {
            type: Number,
            default: 1
        },
        moduleInfo: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data: function() {
        return {
            innerFormVisible: false,
            loginUser: this.$store.getters.loginUser,
            viewFile: false,
            fileList: {},
            httpPort: location.port,
            activeTabName: '0',
            openTabList: [{
                'name': '档案信息',
                'tabName': 'tab_0',
                'key': '1735202167000_71952',
                'index': 0
            }, {
                'name': '任职信息',
                'tabName': 'tab_1',
                'key': '1735202167000_89975',
                'index': 1
            }, {
                'name': '调离信息',
                'tabName': 'tab_2',
                'key': '1735202202000_14448',
                'index': 2
            }, {
                'name': '相关学历及职业技能证书',
                'tabName': 'tab_3',
                'key': '1735202213000_38305',
                'index': 3
            }, {
                'name': '工作成长经历',
                'tabName': 'tab_4',
                'key': '1735202226000_82729',
                'index': 4
            }, {
                'name': '家庭成员',
                'tabName': 'tab_5',
                'key': '1735202237000_75487',
                'index': 5
            }, {
                'name': '变动信息',
                'tabName': 'tab_6',
                'key': '1735202247000_11046',
                'index': 6
            }, {
                'name': '人事合同',
                'tabName': 'tab_7',
                'key': '1735202255000_3130',
                'index': 7
            }],
            dialogFormVisible: false,
            moduleInfo: {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/teacher/familyMembers/form.html', 'addNewUrl': '/xsgl/teacherFamilyMembers/addNew', 'insertUrl': '/xsgl/teacherFamilyMembers/insert', 'getByIdUrl': '/xsgl/teacherFamilyMembers/getById', 'updateUrl': '/xsgl/teacherFamilyMembers/update', 'delUrl': '/xsgl/teacherFamilyMembers/delete', 'listDataUrl': '/xsgl/teacherFamilyMembers/listdata', 'winWidth': 1000, 'winHeight': 600, 'moduleCode': 'familyMembers', 'openViewType': '0', 'listAdvSearchAllFields': 0, 'listAdvSearchExpandPanel': 0}
        }
    },
    watch: {},
    created: function() {
        if (this.$parent.$vnode.context.activeTabIndex) {
            this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        }
        this.$vnode.context.frmFullScreen = 1
        this.$bus.on('tabActive', this.changeTab)
        if (this.$vnode.context.openTabList) {
            this.$vnode.context.openTabList = this.openTabList
        }
        this.$set(this.$vnode.context, 'wfAttach', false)

        this.$options.components['appointmentForm'] = this.$loadComponent('@/wapp/xxgl/teacher/basicInfo/appointmentForm')
        //this.$options.components['workExperience'] = this.$loadComponent('@/wapp/rsgl/archivesInfo/components/RsglWorkExperience')
        //this.$options.components['workBank'] = this.$loadComponent('@/wapp/rsgl/archivesInfo/components/RsglWorkBank')
        //this.$options.components['workCont'] = this.$loadComponent('@/wapp/rsgl/archivesInfo/components/RsglWorkCont')
        //this.$options.components['workPost'] = this.$loadComponent('@/wapp/rsgl/archivesInfo/components/RsglWorkPost')
        //this.$options.components['workPhoto'] = this.$loadComponent('@/wapp/rsgl/archivesInfo/components/RsglWorkPhoto')
        if (this.vo.certificatesName) this.viewFile = true
        this.fileList = {
            certificatesInfo: [],
            archiveInfo: []
        }
        if (this.moduleInfo.formType === 'addNew') {
            this.vo.passenger.appointmnetInfos = []
            this.vo.passenger.workExperiences = []
            this.vo.passenger.certificatesInfos = []
            this.vo.passenger.conInfos = []
            this.vo.passenger.bankcardInfos = []
            if (localStorage.getItem('appointmnetInfos')) {
                const vo = JSON.parse(localStorage.getItem('appointmnetInfos'))
                vo.archivesId = this.vo.id
                this.vo.passenger.appointmnetInfos = [vo]
            }
        }

        let _this = this
        _this.$bus.$on('showTeacherFormDialog', (params) => {
            console.log('params', params)
            _this.type = params.type
            if (params) {
                _this.dialogFormVisible = true
            }
            if (params.type == 1) {
                _this.vo = {
                    ...params.detail
                }
            }
        })
    },
    beforeDestroy: function() {
        this.$bus.$off('showTeacherFormDialog')
    },
    mounted: function() {},
    methods: {
        changeTab: function(val) {
            this.activeTabName = val
        },
        // 内嵌子表-表头按钮方法
        selectGroup(val) {
            let _this = this
            const parentDiv = _this.$refs.parentDiv
            const dialog = _this.$refs.dialog
            const modal = document.querySelector('.el-dialog__wrapper')
            let _modal = document.getElementsByClassName('el-dialog__wrapper')
            console.log('dialog', dialog)
            console.log('parentDiv', parentDiv)
            _this.innerFormVisible = true
            //_modal.style.position = 'relative' ;
            //modal.style.zIndex = 9999 ; // 设置新的层级值
            //_modal.style.zIndex = 9999 ;
            console.log('val', val)
            if (val) {
                _this.vo = {...val}
            } else {

            }
            //this.dialogFormVisible = true;
            _this.moduleInfo.formTemplate = 'dcontent/busiformurl?vwtype=W&url=/teacher/familyMembers/form.html'
            _this.moduleInfo.delUrl = '/xsgl/teacher/familyMembers/delete'
            _this.moduleInfo.addNewUrl = '/xsgl/teacherFamilyMembers/addNew'
            _this.moduleInfo.insertUrl = '/xsgl/teacherFamilyMembers/insert'
            _this.moduleInfo.moduleCode = 'ecyoa'
            _this.moduleInfo.updateUrl = '/xsgl/teacherFamilyMembers/update'

            let formurl = _this.moduleInfo.formTemplate.split('url=')[1]
            formurl = formurl.replace(/\//g, '.')
            formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
            formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
            _this.$options.components['BusiForm'] = this.$loadComponent(formurl)
            // _this.showView="mainform";
            // _this.$emit('closeShow',1);
            _this.$nextTick(function() {
                _this.$bus.emit('openBusiform', _this.moduleInfo, null, 1)
            })
        },
        //	handleTabsClick(index,defer){
        //		if(index==='1'){
        //			this.$message.error('重写标签切换方法')
        //			defer.reject()
        //		}else{
        //			defer.resolve(true)
        //		}
        //	},
        handleUploadChange(filed, fileList) {
            if (filed.name.indexOf('.jpg') === -1 && filed.name.indexOf('.png') === -1 && filed.name
                .indexOf('.JPG') === -1 && filed.name.indexOf('.PNG') === -1) {
                this.$alert('上传文件格式错误', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                return
            }
            filed.id = this.vo.id
            this.fileList.archiveInfo = [filed]
            this.$vnode.context.fileList.archiveInfo = [filed]
            this.vo.certificatesName = filed.name
        },
        onSelectTreeNodeCompleted(val, attr) {
            this.vo.nativePlace = val[0].fullName
            this.vo.provinceId = val[0].fullID.split('-')[0]
            const provinceName = val[0].fullName.split('-')[0]
            if (provinceName === '黑龙江省' || provinceName === '内蒙古自治区' || provinceName === '钓鱼岛') {
                this.vo.provinceName = provinceName.substr(0, 3)
            } else {
                this.vo.provinceName = provinceName.substr(0, 2)
            }
        },
        workAdd() {
            this.$refs.workE.openAddDialog()
        },
        postAdd() {
            this.$refs.workP.addObect()
        },
        onBasicFormSubmited($scope, reloadList) {
            localStorage.removeItem('appointmnetInfos')
            this.uploadfile($scope, reloadList)
        },
        onBasicFormBeforeSubmit($scope, vo, defer) {
            console.log('提交前检查')
            if (!$scope.moduleInfo.addNew) {
                const arr = vo.passenger.conInfos
                vo.startDate = arr.length > 0 ? arr[arr.length - 1].conStartDate : ''
                vo.endDate = arr.length > 0 ? arr[arr.length - 1].conEndDate : ''
            } else {
                this.vo.status = 1
            }
            defer.resolve(true)
        },
        async uploadfile($scope, reloadList) {
            const fiels = []
            if ($scope.fileList.archiveInfo && $scope.fileList.archiveInfo.length > 0) {
                for (let i = 0; i < $scope.fileList.archiveInfo.length; i++) {
                    if ($scope.fileList.archiveInfo[i]) {
                        $scope.fileList.archiveInfo[i].uploadUrl = 'rsgl/archiveInfo/upload'
                        $scope.fileList.archiveInfo[i].nameField = 'certificatesName'
                        $scope.fileList.archiveInfo[i].dataField = 'idPhoto'
                        fiels.push($scope.fileList.archiveInfo[i])
                    }
                }
            }
            if (this.fileList.certificatesInfo && this.fileList.certificatesInfo.length > 0) {
                for (let j = 0; j < this.fileList.certificatesInfo.length; j++) {
                    if (this.fileList.certificatesInfo[j]) {
                        this.fileList.certificatesInfo[j].uploadUrl = 'rsgl/certificatesInfo/upload'
                        fiels.push(this.fileList.certificatesInfo[j])
                    }
                }
            }
            const resopn = []
            for (let z = 0; z < fiels.length; z++) {
                const uploadRst = await this.$app.upload(fiels[z].uploadUrl, fiels[z].raw, {
                    'id': fiels[z].id,
                    'nameField': fiels[z].nameField,
                    'dataField': fiels[z].dataField
                })
                resopn.push(uploadRst)
            }
            let errorMessage = ''
            resopn.forEach((v, x) => {
                if (v.code !== 'success') {
                    if (errorMessage !== '') errorMessage += '、'
                    errorMessage += v.message
                }
                if (x === resopn) {
                    if (errorMessage === '') {
                        this.$message({
                            type: 'success',
                            message: '保存成功！'
                        })
                    } else {
                        this.$message.error('文件保存失败！')
                    }
                }
            })
            reloadList()
        }

    }
}
</script>

<style scoped>
.box-dialog {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100vm;
    height: 100vh;
    z-index: 9999;
    padding: 20px;
    background-color: #fff;
    overflow: hidden;
}
.my-dialog {
    position: fixed;
    top: 0;
    legt: 0;
    right: 0;
    width: 500px;
    height: 500px;
    background-color: aquamarine;
    z-index: 999;
}
        .el-upload .el-upload--text {
            width: 100%;
        }

        .tab_0 .el-table--border,
        .el-table--group {
            border: 1px solid transparent !important;
        }

        .tab_0 .el-table::before {
            height: 0 !important;
        }

        .tab_0 .el-table::after {
            width: 0 !important;
        }

        .tab_0 .el-table tr td:first-child {
            border-left: 1px solid #DEE2E6 !important;
        }

        .tab_1 .el-table--border,
        .el-table--group {
            border: 1px solid transparent !important;
        }

        .tab_1 .el-table::before {
            height: 0 !important;
        }

        .tab_1 .el-table::after {
            width: 0 !important;
        }

        .tab_1 .el-table tr td:first-child {
            border-left: 1px solid #DEE2E6 !important;
        }

        .tab_2 .el-table--border,
        .el-table--group {
            border: none !important;
        }

        .no-border .tab_2 .bank_table .el-table--border {
            border-top: 1px solid #DEE2E6 !important;
        }

        .has-border .tab_2 .el-table__empty-block {
            border-bottom: 1px solid #E2E7ED;
            border-right: 1px solid #E2E7ED;
        }

        .tab_2 .el-table::before {
            height: 0px !important;
        }

        .tab_2 .el-table--border::after {
            width: 0px !important;
        }

        .tab_2 .showTable.el-table--border,
        .el-table--group {
            border-top: 1px solid #E2E7ED !important;
            border-left: 1px solid #E2E7ED !important;
        }

        .tab_2 .bank_table .el-table .column_checkbox {
            border-left: 1px solid #E2E7ED !important;
        }

        .tab_2 .bank_table .el-table td {
            border-right: 1px solid #E2E7ED !important;
        }

        .tab_2 .bank_table .el-table th {
            border-right: 1px solid #E2E7ED !important;
        }

        .tab_3 .el-table--border,
        .el-table--group {
            border: none !important;
        }

        .tab_3 .el-table::before {
            height: 0px !important;
        }

        .tab_3 .el-table--border::after {
            width: 0px !important;
        }

        .tab_3 .el-table tr td:first-child {
            border-left: 1px solid #DEE2E6 !important;
        }

        .spanDiv {
            display: flex;
            align-items: center;
        }

        .spanStatus {
            width: 3px;
            height: 15px;
            background: var(--bgColor);
            margin-right: 4px;
        }

        .spanTitle {
            font-weight: bold;
        }

</style>
